const path = window.require("path");
const fs = window.require("fs");
const { app } = window.require("@electron/remote");
const log = window.require("electron-log");

const DIR_NAME = "media-to-upload";
const DIR_PATH = path?.join(app.getPath("userData"), DIR_NAME);

export function createMediaDirectoryIfNotExisting() {
  if (!fs.existsSync(DIR_PATH)) {
    fs.mkdirSync(DIR_PATH);
  }
}

export function getPathForFileName(fileName) {
  return path.join(DIR_PATH, fileName);
}

export function getPendingFileNames() {
  const fileNames = fs.readdirSync(DIR_PATH);
  return fileNames.filter((filename) => filename.startsWith(".") === false);
}

export function clearData() {
  const fileNames = getPendingFileNames();
  return Promise.all(
    fileNames.map((fileName) => {
      const filePath = path.join(DIR_PATH, fileName);
      return fs.promises.unlink(filePath);
    })
  );
}

export function clearPendingFiles({ filesToPreserve }) {
  getPendingFileNames().forEach((fileName) => {
    const canBeDeleted =
      filesToPreserve.findIndex(
        (fileToPreserve) => fileToPreserve === fileName
      ) === -1;

    if (canBeDeleted) {
      fs.unlink(getPathForFileName(fileName), (error) => {
        error && log.error(error);
      });
    }
  });
}
